<template>
  <div :class="['range-wrapper']">
    <div :class="['range-title']">{{ title }}</div>
    <div class="range-inner">
      <div class="range-from">
        <slot name="from"></slot>
      </div>
      <div class="range-divider">-</div>
      <div class="range-to">
        <slot name="to"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RangeWrapper",
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
.range-wrapper {
  .range-title {
    color: $blueDark;
    font-weight: bold;
    text-align: left;
    margin-bottom: 0.5rem;
  }

  .range-inner {
    display: flex;
    .base-input-title{
      display:none;
    }
  }

  .range-divider {
    font-size: 3rem;
    padding-left: 1rem;
    padding-right: 1rem;
    color: $blueDark;
  }
}
</style>
